import {
  Battery,
  BatteryCharging,
  BatteryFull,
  BatteryLow,
  BatteryMedium,
  Laptop,
  Smartphone,
  TabletSmartphone,
  type LucideProps,
} from 'lucide-react';
import type { Device, DeviceType } from '@findmy/shared';
import { Badge } from './ui';

export function DeviceTypeIcon({ type, ...props }: { type: DeviceType } & LucideProps) {
  switch (type) {
    case 'android':
    case 'ios':
      return <Smartphone {...props} />;
    case 'linux':
    case 'windows':
    case 'macos':
      return <Laptop {...props} />;
    default:
      return <TabletSmartphone {...props} />;
  }
}

export function BatteryIndicator({ pct, charging }: { pct: number | null; charging: boolean | null }) {
  if (pct === null) return null;
  const Icon = charging
    ? BatteryCharging
    : pct <= 15
      ? BatteryLow
      : pct <= 50
        ? BatteryMedium
        : pct <= 90
          ? Battery
          : BatteryFull;
  const low = pct <= 15 && !charging;
  return (
    <span
      className={`inline-flex items-center gap-1 ${low ? 'text-red-600 dark:text-red-400' : ''}`}
      title={charging ? `${pct}% (charging)` : `${pct}%`}
    >
      <Icon className="h-4 w-4" aria-hidden />
      {pct}%<span className="sr-only">{charging ? ' charging' : ''}</span>
    </span>
  );
}

export function DeviceBadges({ device }: { device: Device }) {
  return (
    <>
      {device.revoked && <Badge tone="red">Removed</Badge>}
      {device.isLost && <Badge tone="amber">Lost mode</Badge>}
      {device.sharingPaused && !device.revoked && <Badge tone="grey">Sharing paused</Badge>}
      {device.lastLocation?.source === 'ip' && <Badge tone="grey">Approximate</Badge>}
    </>
  );
}
